import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipPortal = TooltipPrimitive.Portal

const TooltipContent = React.forwardRef(({ className, sideOffset = 4, side = "top", align = "center", children, ...props }, ref) => {
  return (
    <TooltipPortal container={typeof document !== 'undefined' ? document.body : undefined}>
      <TooltipPrimitive.Content
        ref={ref}
        side={side}
        align={align}
        sideOffset={sideOffset}
        collisionPadding={8}
        avoidCollisions={true}
        className={cn(
          "z-[9999] overflow-hidden rounded-xl border border-[rgba(212,175,55,0.25)] px-3.5 py-2.5 max-w-[300px] text-[13px] leading-[1.5] text-white/85 shadow-[0_14px_40px_rgba(0,0,0,0.55)] backdrop-blur bg-[linear-gradient(180deg,rgba(20,24,38,0.97),rgba(13,16,28,0.97))]",
          className
        )}
        {...props}
      >
        {children}
      </TooltipPrimitive.Content>
    </TooltipPortal>
  );
})
TooltipContent.displayName = TooltipPrimitive.Content.displayName

// Simple wrapper for icon buttons with tooltips
const IconButtonWithTooltip = React.forwardRef(({ 
  tooltip, 
  children, 
  className,
  side = "top",
  asChild = false,
  ...props 
}, ref) => (
  <Tooltip delayDuration={200}>
    <TooltipTrigger asChild={asChild} ref={ref} className={className} {...props}>
      {children}
    </TooltipTrigger>
    <TooltipContent side={side}>
      {tooltip}
    </TooltipContent>
  </Tooltip>
))
IconButtonWithTooltip.displayName = "IconButtonWithTooltip"

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, IconButtonWithTooltip }
